import React, { useEffect } from 'react';

export const useOnClickOutside = (ref: React.RefObject<any>, handler: () => void) => {
    useEffect(() => {
        /**
         * Handler is called if clicked on outside of element
         */
        const listener = (event: TouchEvent | MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        document.addEventListener("mousedown", listener);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", listener);
        };
    }, [ref, handler]);
}
